module.exports = __webpack_public_path__ + "img/checkmark.1cd784b8.svg";